import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      {/* INSTAGRAM GRADIENT DEFINITION (same as Contact page) */}
      <svg width="0" height="0">
        <defs>
          <linearGradient id="instaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#feda75" />
            <stop offset="25%" stopColor="#fa7e1e" />
            <stop offset="50%" stopColor="#d62976" />
            <stop offset="75%" stopColor="#962fbf" />
            <stop offset="100%" stopColor="#4f5bd5" />
          </linearGradient>
        </defs>
      </svg>

      <div className="footer-content">

        {/* SECTION 1 */}
        <div className="footer-section">
          <h3>Fan & GenZ - Travel Club</h3>
          <p>{t('heroText')}</p>
        </div>

        {/* SECTION 2 */}
        <div className="footer-section">
          <h4>{t('quickLinks')}</h4>
          <ul>
            <li><Link to="/">{t('home')}</Link></li>
            <li><Link to="/tours">{t('tours')}</Link></li>
            <li><Link to="/about">{t('about')}</Link></li>
            <li><Link to="/contact">{t('contact')}</Link></li>
          </ul>
        </div>

        {/* SECTION 3 */}
        <div className="footer-section">
          <h4>{t('contactInfo')}</h4>
          <p>📞 +995 577 430 102</p>
          <p>✉️ contact@geofansgenz.com</p>
          <p>📍 Tbilisi, Georgia</p>
        </div>

        {/* SECTION 4 — SOCIAL ICONS */}
        <div className="footer-section footer-social">
          <h4>{t('followUs')}</h4>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/fgtravelclub"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-link icon-instagram"
          >
            <svg viewBox="0 0 24 24" className="icon">
              <path d="M7 2C4.24 2 2 4.24 2 7v10c0 2.76 2.24 5 
                5 5h10c2.76 0 5-2.24 5-5V7c0-2.76-2.24-5-5-5H7zm10 
                2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 
                1-3-3V7a3 3 0 0 1 3-3h10zm-5 3a5 5 0 1 0 0 
                10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 
                0 0 1 0-6zm4.5-.25a1.25 1.25 0 1 1 0-2.5 
                1.25 1.25 0 0 1 0 2.5z" />
            </svg>
            Instagram
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/fgtravelclub"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-link icon-facebook"
          >
            <svg viewBox="0 0 24 24" className="icon">
              <path d="M22 12a10 10 0 1 0-11.5 9.9v-7h-2v-3h2v-2.3c0-2 
                1.2-3.1 3-3.1 .9 0 1.8.1 2 .1v2.3h-1.1c-1 
                0-1.3.6-1.3 1.2V12h2.6l-.4 3h-2.2v7A10 
                10 0 0 0 22 12" />
            </svg>
            Facebook
          </a>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>{t('copyright')}</p>
      </div>
    </footer>
  );
};

export default Footer;